<div class="px-6 py-4 border-b border-gray-100 bg-white flex flex-row justify-between items-center gap-4">
  <div class="flex items-center gap-3">
    <span class="h-10 w-10 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center flex-shrink-0"><mat-icon>assignment_return</mat-icon></span>
    <div>
      <h1 class="text-xl font-bold text-gray-900 leading-tight">New return</h1>
      <p class="text-xs text-gray-500">Find the order, then pick what's coming back</p>
    </div>
  </div>
  <button type="button" (click)="dialogRef.close({ status: false })" class="h-9 w-9 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800 flex items-center justify-center text-sm transition-colors flex-shrink-0" aria-label="Close" matTooltip="Close dialog">✕</button>
</div>

<mat-dialog-content class="mat-typography !px-6 !py-5 !max-h-[68vh]">

  <div class="flex items-end gap-2">
    <div class="flex-1 max-w-xs">
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Order number</label>
      <input type="number" placeholder="e.g. 99215903"
        class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm"
        name="return-order-no" [(ngModel)]="orderNoSearch" (keyup.enter)="search()" />
    </div>
    <button type="button" class="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-neutral-900 text-white text-sm font-semibold hover:bg-neutral-700 transition-colors disabled:opacity-50" (click)="search()" [disabled]="loading">
      <mat-icon class="!text-[18px] !h-[18px] !w-[18px] !text-amber-400">search</mat-icon> Find order
    </button>
  </div>

  @if (loading) {
  <div class="flex justify-center py-10"><mat-spinner diameter="32"></mat-spinner></div>
  }

  @if (searched && !loading && !order) {
  <div class="mt-6 rounded-2xl border border-gray-100 bg-gray-50/60 p-6 text-center text-sm text-gray-500">No order found for that number - check it and try again.</div>
  }

  @if (order && !loading) {
  <div class="mt-6">
    <div class="flex items-center gap-2 mb-3">
      <span class="text-sm font-bold text-gray-900">Order #{{ order.orderNo }}</span>
      <span class="text-xs text-gray-400">select the items being returned</span>
    </div>

    <div class="rounded-2xl border border-gray-100 overflow-hidden">
      <table class="w-full text-sm">
        <thead class="bg-gray-50 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
          <tr>
            <th class="p-3 w-10"></th>
            <th class="p-3">Product</th>
            <th class="p-3 w-20 text-right">Ordered</th>
            <th class="p-3 w-28">Return qty</th>
            <th class="p-3 w-48">Condition</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.item.id) {
          <tr class="border-t border-gray-100" [class.bg-amber-50]="row.selected">
            <td class="p-3"><input type="checkbox" class="h-4 w-4 accent-amber-500 cursor-pointer" [ngModel]="row.selected" (ngModelChange)="toggleRow(row)" [attr.aria-label]="'Select ' + row.item.productName" /></td>
            <td class="p-3 text-gray-800">{{ row.item.productName }}</td>
            <td class="p-3 text-right text-gray-500">{{ row.item.quantity }}</td>
            <td class="p-3">
              <input type="number" min="1" [max]="row.item.quantity" [disabled]="!row.selected"
                class="w-20 px-2 py-1.5 rounded-lg border text-center outline-none transition-all disabled:opacity-40 disabled:bg-gray-50"
                [class]="invalidQty(row) ? 'border-red-400 ring-2 ring-red-100' : 'border-gray-200 focus:border-amber-400 focus:ring-4 focus:ring-amber-100 bg-gray-50 focus:bg-white'"
                [(ngModel)]="row.quantity" />
            </td>
            <td class="p-3">
              <select class="w-full px-2 py-1.5 rounded-lg border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 outline-none text-sm disabled:opacity-40" [(ngModel)]="row.condition" [disabled]="!row.selected">
                @for (c of conditionOptions; track c.value) { <option [value]="c.value">{{ c.label }}</option> }
              </select>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="mt-4">
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Reason</label>
      <input type="text" placeholder="Why is this being returned?"
        class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm"
        name="return-reason" [(ngModel)]="reason" />
    </div>
  </div>
  }
</mat-dialog-content>

@if (order) {
<div class="px-6 py-4 border-t border-gray-100 bg-white flex flex-row items-center justify-between gap-3">
  <span class="text-xs text-gray-500">{{ selectedCount ? selectedCount + ' item' + (selectedCount === 1 ? '' : 's') + ' selected' : 'Select at least one item' }}</span>
  <div class="flex gap-3">
    <button type="button" (click)="dialogRef.close({ status: false })" class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors">Cancel</button>
    <button type="button" [disabled]="!selectedCount || submitting" (click)="onSubmit()"
      class="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none">
      @if (submitting) { <span class="inline-block h-4 w-4 rounded-full border-2 border-neutral-900 border-t-transparent animate-spin"></span> }
      Create return
    </button>
  </div>
</div>
}
